import { graphql } from 'react-relay';

import { type FragmentRef } from '@confluence/apollo-relay-interop/entry-points/useFragmentizedQuery';
import { useFragmentizedFragment } from '@confluence/apollo-relay-interop/entry-points/useFragmentizedFragment';

import type { ContentTypesHeaderQueryNode } from './ContentTypesHeader';
import type { useContentBasicInfoFragment$data } from './__generated__/useContentBasicInfoFragment.graphql';

type ContentBasicInfo = Omit<useContentBasicInfoFragment$data, ' $fragmentType'>;
export const useContentBasicInfo = (
	contentBasicInfoRef: FragmentRef,
	externalShareContent?: ContentTypesHeaderQueryNode | null,
): ContentBasicInfo | null => {
	if (externalShareContent) {
		return {
			id: externalShareContent.id,
			title: externalShareContent.title,
			type: externalShareContent.type,
			subType: externalShareContent.subType,
			status: externalShareContent.status,
		};
	}

	// eslint-disable-next-line react-hooks/rules-of-hooks
	return useFragmentizedFragment<ContentBasicInfo>(
		graphql`
			fragment useContentBasicInfoFragment on Content {
				id
				title
				type
				subType
				status
			}
		`,
		contentBasicInfoRef,
	);
};
